import { derived, writable } from "svelte/store";
import type { Versions } from "../types";

export const mobileStore = writable<{
    versions: Versions;
    needsUpdate: boolean;
	isAppSupported: boolean;
	isAppReady: boolean;
} | null>(null);

export const isAppSupported = derived(mobileStore, ($mobileStore) => $mobileStore?.isAppSupported);
export const isAppReady = derived(mobileStore, ($mobileStore) => $mobileStore?.isAppReady);

export function initializeMobileStore(versions: Versions, needsUpdate: boolean, isAppSupported: boolean, isAppReady: boolean){
	mobileStore.set({
		versions,
		needsUpdate,
		isAppSupported,
		isAppReady,
	});
}
